import React, { useId } from "react";
import Box from "@mui/material/Box";

const VIEW = 48;
const CX = VIEW / 2;
const CY = VIEW / 2;
const RADIUS = 18.5;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
const SWEEP_RATIO = 0.28;
const SWEEP_LENGTH = CIRCUMFERENCE * SWEEP_RATIO;
const SWEEP_GAP = CIRCUMFERENCE - SWEEP_LENGTH;

/** Clean gold sweep used across lobby, global, and persistent queue states. */
function MatchSearchLoader({ size = "large", diameter }) {
    const compact = size === "compact";
    const resolvedDiameter = diameter ?? (compact ? 28 : 88);
    const rawId = useId().replace(/:/g, "");
    const sweepId = `${rawId}-sweep`;
    const trackWidth = compact ? 2.6 : 2.15;
    const sweepWidth = compact ? 3 : 2.55;

    return (
        <Box
            aria-hidden="true"
            sx={{
                width: resolvedDiameter,
                height: resolvedDiameter,
                flex: "0 0 auto",
                lineHeight: 0,
                "@keyframes ouroSearchSweep": {
                    to: { transform: "rotate(360deg)" },
                },
                "& .ouro-search-sweep": {
                    transformBox: "view-box",
                    transformOrigin: "center",
                    animation: "ouroSearchSweep 0.95s linear infinite",
                    willChange: "transform",
                },
                "@media (prefers-reduced-motion: reduce)": {
                    "& .ouro-search-sweep": { animation: "none" },
                },
            }}
        >
            <svg
                width="100%"
                height="100%"
                viewBox={`0 0 ${VIEW} ${VIEW}`}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <defs>
                    <linearGradient
                        id={sweepId}
                        x1="10"
                        y1="6"
                        x2="38"
                        y2="42"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#FFF3C8" />
                        <stop offset="0.45" stopColor="#E8A33D" />
                        <stop offset="1" stopColor="#A56B1E" />
                    </linearGradient>
                </defs>

                <circle
                    cx={CX}
                    cy={CY}
                    r={RADIUS}
                    fill="none"
                    stroke="#E8A33D"
                    strokeOpacity="0.22"
                    strokeWidth={trackWidth}
                />

                <g className="ouro-search-sweep">
                    <circle
                        cx={CX}
                        cy={CY}
                        r={RADIUS}
                        fill="none"
                        stroke={`url(#${sweepId})`}
                        strokeWidth={sweepWidth}
                        strokeLinecap="round"
                        strokeDasharray={`${SWEEP_LENGTH} ${SWEEP_GAP}`}
                        transform={`rotate(-90 ${CX} ${CY})`}
                    />
                </g>
            </svg>
        </Box>
    );
}

export default MatchSearchLoader;
